import axios from 'axios';
import { Permission, Role } from '../models/roles';
import { JsonResponse, Pagination } from 'core/models/response';
import environment from 'environment';

interface GetRolesResponse {
	roles: Role[];
	pagination:Pagination;
}

interface GetPermissionsResponse {
	permissions: Permission[];
}

export const onGetRoles = (page = 1) => {
	return axios.get<JsonResponse<GetRolesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/roles`, {
		params: {
			page,
		},
	});
};

export const onGetAllRoles = () => {
	return axios.get<JsonResponse<GetRolesResponse>>(`${environment.BASE_API_ENDPOINT}/global/roles`);
};

export const onGetRole = (roleId: string) => {
	return axios.get<JsonResponse<Role>>(`${environment.BASE_API_ENDPOINT}/admin/roles/${roleId}`);
};

export const onCreateRole = (name: string, guard_name: string, permissions: number[]) => {
	return axios.post<JsonResponse<GetRolesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/roles`, {
		name,
		guard_name,
		permissions,
	});
};

export const onUpdateRole = (roleId: string, permissions: number[]) => {
	return axios.put<JsonResponse<GetRolesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/roles/${roleId}`, {
		permissions,
	});
};

export const onDeleteRole = (roleId: number) => {
	return axios.delete<JsonResponse<GetRolesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/roles/${roleId}`);
};

export const onGetPermissions = () => {
	return axios.get<JsonResponse<GetPermissionsResponse>>(`${environment.BASE_API_ENDPOINT}/global/permissions`);
};
